import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '@/views/Home.vue';
import Road from '../views/Road.vue';
import Inside from '../views/Inside.vue';
import Details from '../views/Details.vue';


Vue.use(VueRouter);

const routes = [
    {
        path: '/',
        name: 'Home',
        component: Home,
    },
    {
        path: '/road',
        name: 'Road',
        component: Road,
    },
    {
        path: '/inside',
        name: 'Inside',
        component: Inside,
    },
    {
        path: '/details',
        name: 'Details',
        component: Details,
    },
];

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition;
        }
        if (to.hash) {
            return {
                selector: to.hash,
                behavior: 'smooth'
            };
        }
        return { x: 0, y: 0 };
    },
});

export default router;
